import React from "react";
import {
  t,
  HEADING1,
  HEADING2,
  CLASSIFICATION_OF_LUGGAGE,
  LL_HEADING,
  LL_P1,
  LL_LI1,
  LL_LI2,
  LL_LI3,
  LL_LI4,
  HL_HEADING,
  HL_P1,
  HL_LI1,
  HL_LI2,
  HL_LI3,
  HL_LI4,
  HL_LI5,
  PA_HEADING,
  PA_LINE1,
  PA_LINE2,
  PA_LINE3,
  PETA_HEADING,
  PETA_LI1,
  PETA_LI2,
  PETA_LI3,
  PETA_LI4,
  PETA_NOTE,
  PETA_NOTE_TXT,
  COCOON_HEADING,
  COCOON_P1,
  FA_HEADING,
  FA_LI1,
  FA_LI2,
  FA_LI3,
  FA_LI4,
  FA_LI5,
  FA_LI6,
  LUGGAGE_RATES,
  LR_P1,
  LR_P2,
  LR_P3,
  LR_P4,
  LR_P5,
  LR_RS,
  PROHIBITED_LUGGAGES,
  PL_PETROL_GAS_KEROSENE,
  PL_ALCOHOL,
  PL_GASOLINE,
  PL_SPIRIT_TURPENTINE,
  PL_ACID,
  PL_SULPHER,
  PL_COOL_TAR,
  IMP_TNC,
  IMP_LI1,
  IMP_LI2,
  IMP_LI3,
  IMP_LI4,
  IMP_LI5,
  IMP_LI6,
  IMP_LI7,
} from "../../translations/AboutUs/LuggageRates";

function LuggageRates() {
  return (
    <div className="body_style_luggage">
      <div className="letters-color-section-luggage">
        <h3 className="letters-color-section-main-heading-luggage">
          {t(HEADING1)}
        </h3>
        <div className="letters-color-section-sub-heading-section-luggage">
          <h5 className="letters-color-section-sub-heading-luggage">
            {t(HEADING2)}
          </h5>
        </div>
        <div className="letters-color-section-table-section-luggage">
          {t(CLASSIFICATION_OF_LUGGAGE)}
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}> {t(LL_HEADING)}</span>
            <div className="letters-color-section-table-section-sub-luggage">
              {t(LL_P1)}
            </div>
            <div>
              <ul>
                <li>{t(LL_LI1)}</li>
                <li>{t(LL_LI2)}</li>
                <li>{t(LL_LI3)}</li>
                <li>{t(LL_LI4)}</li>
              </ul>
            </div>
          </div>
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}> {t(HL_HEADING)}</span>
            <div className="letters-color-section-table-section-sub-luggage">
              {t(HL_P1)}
            </div>
            <div>
              <ul>
                <li> {t(HL_LI1)}</li>
                <li>{t(HL_LI2)}</li>
                <li>{t(HL_LI3)}</li>
                <li>{t(HL_LI4)}</li>
                <li>{t(HL_LI5)}</li>
              </ul>
            </div>
          </div>
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}> {t(PA_HEADING)}</span>
            <div className="letters-color-section-table-section-sub-luggage">
              <table>
                <tr>
                  <td>{t(PA_LINE1)}</td>
                  <td className="td-second">3 units ( 60 kgs)</td>
                </tr>
                <tr>
                  <td>{t(PA_LINE2)}</td>
                  <td className="td-second">2 units ( 40 kgs)</td>
                </tr>
                <tr>
                  <td>{t(PA_LINE3)}</td>
                  <td className="td-second">1 unit (20 kgs)</td>
                </tr>
              </table>
            </div>
          </div>
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}> {t(PETA_HEADING)}</span>
            <div className="letters-color-section-table-section-sub-luggage">
              <ul>
                <li>{t(PETA_LI1)}</li>
                <li>{t(PETA_LI2)}</li>
                <li>{t(PETA_LI3)}</li>
                <li>{t(PETA_LI4)}</li>
              </ul>
            </div>
            <div>
              <span className="letters-color-section-table-section-span-luggage">
                {t(PETA_NOTE)}
              </span>
              {t(PETA_NOTE_TXT)}
            </div>
          </div>
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}>{t(COCOON_HEADING)} </span>
            <div className="letters-color-section-table-section-sub-luggage">
              {t(COCOON_P1)}
            </div>
          </div>
          <div className="letters-color-section-table-section-main-luggage">
            <span style={{ fontWeight: "bold" }}> {t(FA_HEADING)}</span>
            <div className="letters-color-section-table-section-sub-luggage">
              <ul>
                <li>{t(FA_LI1)}</li>
                <li>{t(FA_LI2)}</li>
                <li>{t(FA_LI3)}</li>
                <li>{t(FA_LI4)}</li>
                <li>{t(FA_LI5)}</li>
                <li>{t(FA_LI6)}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="letters-color-section-table-section-luggage">
          {t(LUGGAGE_RATES)}
          <div className="letters-color-section-table-section-main-luggage">
            {t(LR_P1)}
            <div className="letters-color-section-table-section-sub-luggage">
              <table>
                <tr>
                  <td>{t(LR_P2)}</td>
                  <td>{t(LR_P3)}</td>
                  <td>
                    {t(LR_P4)} ({t(LR_RS)}.)
                  </td>
                </tr>
                <tr>
                  <td>{t(LR_P5)}</td>
                  <td>{t(LR_RS)}. 0.75/-</td>
                  <td>{t(LR_RS)}. 5/-</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div className="letters-color-section-table-section-luggage">
          {t(PROHIBITED_LUGGAGES)}
          <div className="letters-color-section-table-section-main-luggage">
            <div className="letters-color-section-table-section-sub-luggage">
              <div className="letters-color-section-table-section-sub-menu-luggage">
                <ul>
                  <li>{t(PL_PETROL_GAS_KEROSENE)}</li>
                  <li>{t(PL_ALCOHOL)}</li>
                  <li>{t(PL_GASOLINE)}</li>
                  <li>{t(PL_SPIRIT_TURPENTINE)}</li>
                  <li>{t(PL_ACID)}</li>
                  <li>{t(PL_SULPHER)}</li>
                  <li>{t(PL_COOL_TAR)}</li>
                </ul>
                <ul>
                  <li>{t(PL_PETROL_GAS_KEROSENE)}</li>
                  <li>{t(PL_ALCOHOL)}</li>
                  <li>{t(PL_GASOLINE)}</li>
                  <li>{t(PL_SPIRIT_TURPENTINE)}</li>
                  <li>{t(PL_ACID)}</li>
                  <li>{t(PL_SULPHER)}</li>
                  <li>{t(PL_COOL_TAR)}</li>
                </ul>
                <ul>
                  <li>{t(PL_PETROL_GAS_KEROSENE)}</li>
                  <li>{t(PL_ALCOHOL)}</li>
                  <li>{t(PL_GASOLINE)}</li>
                  <li>{t(PL_SPIRIT_TURPENTINE)}</li>
                  <li>{t(PL_ACID)}</li>
                  <li>{t(PL_SULPHER)}</li>
                  <li>{t(PL_COOL_TAR)}</li>
                </ul>
                <ul>
                  <li>{t(PL_PETROL_GAS_KEROSENE)}</li>
                  <li>{t(PL_ALCOHOL)}</li>
                  <li>{t(PL_GASOLINE)}</li>
                  <li>{t(PL_SPIRIT_TURPENTINE)}</li>
                  <li>{t(PL_ACID)}</li>
                  <li>{t(PL_SULPHER)}</li>
                  <li>{t(PL_COOL_TAR)}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="letters-color-section-table-section-luggage">
          {t(IMP_TNC)}
          <div className="letters-color-section-table-section-main-luggage">
            <div className="letters-color-section-table-section-sub-luggage">
              <ul>
                <li>{t(IMP_LI1)}</li>
                <li>{t(IMP_LI2)}</li>
                <li>{t(IMP_LI3)}</li>
                <li>{t(IMP_LI4)}</li>
                <li>{t(IMP_LI5)}</li>
                <li>{t(IMP_LI6)}</li>
                <li>{t(IMP_LI7)}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LuggageRates;
